module.exports = __webpack_public_path__ + "img/medal3.5e9a1334.png";